




import { defineComponent, PropType } from '@vue/composition-api';
import { TranslateResult } from 'vue-i18n';

export default defineComponent({
  props: {
    desc: {
      type: String as PropType<string | TranslateResult>,
      default: '',
    },
  },
});
